import { render, staticRenderFns } from "./AdminGuid.vue?vue&type=template&id=542a3650&scoped=true&"
import script from "./AdminGuid.vue?vue&type=script&lang=js&"
export * from "./AdminGuid.vue?vue&type=script&lang=js&"
import style0 from "./AdminGuid.vue?vue&type=style&index=0&id=542a3650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a3650",
  null
  
)

export default component.exports